(function () {
  var root = document.querySelector('[data-pz-root]');
  if (!root) return;

  var trigger = document.querySelector('[data-pz-trigger]');
  var overlay = document.querySelector('[data-pz-overlay]');
  var closeBtn = root.querySelector('[data-pz-close]');

  document.body.appendChild(overlay);
  document.body.appendChild(root);

  var lockedScrollY = 0;

  function getCurrentVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var input = form && (form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]'));
    return (input && input.value) || state.mainVariantId;
  }

  function syncVariant() {
    var freshId = getCurrentVariantId();
    if (!freshId || freshId === state.mainVariantId) return;
    state.mainVariantId = freshId;
    fetch(window.location.pathname + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var variant = data.variants.find(function (v) { return String(v.id) === String(freshId); });
        if (variant) {
          state.basePrice = variant.price / 100;
          updateTotal();
        }
      });
  }

  function openDrawer() {
    lockedScrollY = window.scrollY;
    syncVariant();
    root.style.visibility = 'visible';
    root.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedScrollY + 'px';
    document.body.style.width = '100%';
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
    setTimeout(function () {
      root.style.visibility = 'hidden';
    }, 250);
  }

  trigger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  var state = {
    mainVariantId: root.dataset.mainVariantId,
    basePrice: parseFloat(root.dataset.basePrice),
    font: 'Classic',
    priority: false,
    review: true,
    note: false
  };

  var addons = {
    priority: { id: root.dataset.priorityVariantId, price: parseFloat(root.dataset.priorityPrice) },
    review: { id: root.dataset.reviewVariantId, price: parseFloat(root.dataset.reviewPrice) },
    note: { id: root.dataset.noteVariantId, price: parseFloat(root.dataset.notePrice) }
  };

  function formatMoney(amount) {
    return amount.toFixed(2).replace('.', ',') + '€';
  }

  var nameInput = root.querySelector('[data-pz-field="pet-name"]');
  var phoneInput = root.querySelector('[data-pz-field="pet-phone"]');
  var previewWrap = root.querySelector('[data-pz-preview-wrap]');
  var previewName = root.querySelector('[data-pz-preview-name]');
  var previewPhone = root.querySelector('[data-pz-preview-phone]');

  function updatePreview() {
    var name = nameInput.value.trim();
    var phone = phoneInput.value.trim();
    previewName.textContent = name;
    previewPhone.textContent = phone;
    previewWrap.hidden = name.length === 0 && phone.length === 0;
  }

  nameInput.addEventListener('input', function () {
    root.querySelector('[data-pz-charcount="name"]').textContent = nameInput.value.length + '/20';
    updatePreview();
  });

  phoneInput.addEventListener('input', function () {
    root.querySelector('[data-pz-charcount="phone"]').textContent = phoneInput.value.length + '/20';
    updatePreview();
  });

  var fontGroup = root.querySelector('[data-pz-pills="font"]');
  fontGroup.addEventListener('click', function (e) {
    var btn = e.target.closest('.pz__pill');
    if (!btn) return;
    fontGroup.querySelectorAll('.pz__pill').forEach(function (p) { p.classList.remove('is-active'); });
    btn.classList.add('is-active');
    state.font = btn.dataset.value;
    previewName.style.fontFamily = btn.style.fontFamily;
    previewPhone.style.fontFamily = btn.style.fontFamily;
  });

  var priorityToggle = root.querySelector('[data-pz-toggle="priority"]');
  priorityToggle.addEventListener('change', function () {
    state.priority = priorityToggle.checked;
    updateTotal();
  });

  var reviewToggle = root.querySelector('[data-pz-toggle="review"]');
  reviewToggle.addEventListener('change', function () {
    state.review = reviewToggle.checked;
    updateTotal();
  });

  var noteToggle = root.querySelector('[data-pz-toggle="note"]');
  noteToggle.addEventListener('change', function () {
    state.note = noteToggle.checked;
    updateTotal();
  });

  function updateTotal() {
    var total = state.basePrice;
    if (state.priority) total += addons.priority.price;
    if (state.review) total += addons.review.price;
    if (state.note) total += addons.note.price;
    root.querySelector('[data-pz-total]').textContent = formatMoney(total);
  }

  var errorEl = root.querySelector('[data-pz-error]');
  var submitBtn = root.querySelector('[data-pz-submit]');

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  submitBtn.addEventListener('click', function () {
    errorEl.hidden = true;
    var nameVal = nameInput.value.trim();
    var phoneVal = phoneInput.value.trim();
    if (!nameVal) {
      showError('Γράψε το όνομα του κατοικιδίου πριν συνεχίσεις.');
      nameInput.focus();
      return;
    }
    if (!phoneVal) {
      showError('Γράψε τηλέφωνο επικοινωνίας πριν συνεχίσεις.');
      phoneInput.focus();
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Προσθήκη...';

    var properties = {
      'Όνομα Κατοικιδίου': nameVal,
      'Τηλέφωνο Επικοινωνίας': phoneVal,
      'Επιλογή Γραμματοσειράς': state.font
    };
    var notesVal = root.querySelector('[data-pz-field="notes"]').value.trim();
    if (notesVal) properties['Παρατηρήσεις - Σχόλια'] = notesVal;

    var items = [{ id: getCurrentVariantId(), quantity: 1, properties: properties }];
    if (state.priority) items.push({ id: addons.priority.id, quantity: 1 });
    if (state.review) items.push({ id: addons.review.id, quantity: 1 });
    if (state.note) items.push({ id: addons.note.id, quantity: 1 });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart-add-failed');
        return r.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        showError('Κάτι πήγε στραβά. Δοκίμασε ξανά.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Προσθήκη στο Καλάθι';
      });
  });

  updateTotal();
})();
